import React from 'react';
import { useAuth } from "../../../context/contextAuth";
import { usePayment } from "../../../context/contextPayment";
import { useNavigate } from 'react-router-dom';

const TestBtn = () => {
  const {
    getPaymentLink,
    loadingPlanId,
    setLoadingPlanId,
  } = usePayment();
  const { userId } = useAuth();
  const navigate = useNavigate();
  const plan_id = 'plan_RgMaDMhUIAyPSS';
  const quantity = 1;

  const handleGetTestPaymentLink = async () => {    
    if (loadingPlanId) return;
    setLoadingPlanId(plan_id);
    
    try {
      await getPaymentLink(userId, plan_id, quantity);
      // navigate('/dashboard', { replace: true });
    } catch (error) {
      console.error("Payment Link Generation Failed:", error);
    } finally {
      console.log("Process Completed");
      setLoadingPlanId(null);
    }
  };

  return (
    <div className="btn-area mb-1 mt-3 d-flex justify-content-center">
      <button className="btn btn-primary rounded-3 px-4 py-2 w-100 fw-semibold"
        onClick={() => handleGetTestPaymentLink()}>
        {loadingPlanId === plan_id ? (
          "Processing..."
        ) : (
          "Test Plan"
        )}
      </button>
    </div>
  )
};

export default TestBtn;
